<template>
    <img :src="url" @load="$emit('loaded')" />
</template>

<script>
export default {
  data() {
    return {
      image: null,
    };
  },
  mounted() {
    // if (this.name == "OCR") {
    //   this.$emit("resetZoom");
    // }
  },
  methods: {},
  props: {
    url: String,
    imageId: Number,
    arrayBuffer: String,
    name: String,
    isSelected: Boolean,
  },
};
</script>

<style>
</style>
